import TimelineMax from 'TimelineMax'
import { select } from "@assets/scripts/utils";

export default function () {
    let svg = select('.i2')[0]
    if(!svg) return
    svg = svg.contentDocument

    // Str 1
    const strings1mask = svg.querySelector('.i2__strings1-mask')
    const s1m = new TimelineMax()
    s1m.fromTo(strings1mask, 1, { y: '-61%' }, { y: '0%', ease: SteppedEase.config(2) }).repeat(-1)

    // Str 2
    const strings2mask = svg.querySelector('.strings2mask')
    const s2tl = new TimelineMax()
    s2tl.fromTo(strings2mask, 2, { y: '-80%' }, { y: '0%', ease: SteppedEase.config(3) }).repeat(-1)

    // Hand
    const hand = svg.querySelector('.i2__hand')
    const handTl = new TimelineMax()
    handTl.fromTo(hand, 1, { y: '-10%' }, { y: '0%', ease: SteppedEase.config(2) }).repeat(-1)

    // Gear left
    const gear = svg.querySelector('.i2__gear')
    const gearTl =  new TimelineMax()
    gearTl.to(gear, 1, { transformOrigin: '50% 50%', rotation: 360, ease: SteppedEase.config(5) }).repeat(-1)

    // Gear Rigt
    const gearRight = svg.querySelector('.i2__gear-right')
    const gearRightTl = new TimelineMax()
    gearRightTl.to(gearRight, 2, { transformOrigin: '50% 50%',  rotation: 360, ease: SteppedEase.config(5) }).repeat(-1)

    const strings3 = svg.querySelector('.strings3mask')
    const strings3tl = new TimelineMax()
    strings3tl.fromTo(strings3, 1, { y: '-80%' }, { y: '0%', ease: SteppedEase.config(2) }).repeat(-1)

    // Light
    const light = svg.querySelector('.light1')
    const lightTl = new TimelineMax
    lightTl.set(light, { autoAlpha: 0 }, 1).set(light, { autoAlpha: 1 }, 1.25).repeat(-1)
}
